<script lang="ts" setup>
import { useAccountMenu } from '@/composables/useAccountMenu'

/** App-bar menu item that logs the user out. */
const { forceLogout } = useAccountMenu()
</script>

<template>
  <v-list-item @click="forceLogout()">
    <v-list-item-title>Log Out</v-list-item-title>
    <template #append>
      <v-icon>mdi-logout</v-icon>
    </template>
  </v-list-item>
</template>
